import Immutable from "seamless-immutable";
import Api from "../lib/api";

export const SET_FOLDERS = "SET_FOLDERS";
export const SET_FOLDER = "SET_FOLDER";
export const ADD_FOLDER = "ADD_FOLDER";
export const UPDATE_FOLDER = "UPDATE_FOLDER";
export const DELETE_FOLDER = "DELETE_FOLDER";

export const loadFolders = ({
  type,
  perPage,
  page,
  sortBy,
  sortDirection,
  organizationId,
  workspaceId,
} = {}) => {
  return async (dispatch) => {
    let { folders, total } = await Api.getFolders({
      type,
      perPage,
      page,
      sortBy,
      sortDirection,
      organizationId,
      workspaceId,
    });
    console.log("loaded folders", folders, total);
    dispatch({
      type: SET_FOLDERS,
      folders,
      foldersCount: total,
    });
  };
};

export const updateFolder = ({
  folder,
  name,
  organizationId,
  slug,
  userIds,
}) => {
  return async (dispatch) => {
    let update = await Api.updateFolder({
      folderId: folder.id,
      name,
      organizationId,
      slug,
      userIds,
    });
    if (update) {
      dispatch({
        type: UPDATE_FOLDER,
        folderId: folder.id,
        data: update,
      });
    }

    return update;
  };
};

export const createFolder = ({ name, organizationId, slug, type, userIds }) => {
  return async (dispatch) => {
    let folder = await Api.createFolder({
      name,
      organizationId,
      slug,
      type,
      userIds,
    });
    if (folder) {
      dispatch({
        type: ADD_FOLDER,
        folder,
      });
    }
    return folder;
  };
};

export const deleteFolder = ({ folder }) => {
  return async (dispatch) => {
    await Api.deleteFolder({ folderId: folder.id });
    dispatch({
      type: DELETE_FOLDER,
      folder,
    });
  };
};

export const loadFolder = ({ folderId }) => {
  return async (dispatch) => {
    let folder = await Api.getOneFolder({ folderId });
    dispatch({
      type: SET_FOLDER,
      folder,
    });
  };
};

const updateFolderInState = ({ state, action }) => {
  const { folderId, data } = action;
  let folders = state.folders.map((folder) => {
    if (folder.id === folderId) {
      return folder.merge(data);
    }
    return folder;
  });
  state = state.set("folders", folders);
  if (state.folder && state.folder.id === folderId) {
    state = state.set("folder", state.folder.merge(data));
  }
  return state;
};

const initialState = Immutable({ users: [] });

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_FOLDER:
      return state.set("folders", [action.folder].concat(state.folders));
    case DELETE_FOLDER:
      return state.set(
        "folders",
        state.folders.filter((folder) => {
          console.log("delete folder", action.folder.id);
          return folder.id !== action.folder.id;
        })
      );
    case UPDATE_FOLDER:
      return updateFolderInState({ state, action });
    case SET_FOLDER:
      return state.set("folder", action.folder);
    case SET_FOLDERS:
      return state
        .set("folders", action.folders)
        .set("foldersCount", action.foldersCount);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/actions/folders.js